import { useState, useEffect } from "react";
import axiosInstance from "../../../api/axios";
import DataTable from "../../table/DataTable";
import "../../../clients.css";

const columns = [
  { id: "id", label: "#" },
  { id: "companyName", label: "Cég" },
  { id: "message", label: "Értesítés üzenete" },
  { id: "fullNames", label: "Értesítés címzettjei" },
  { id: "notificationType", label: "Értesítés típusa" },
  { id: "timer", label: "Időzített" },
  { id: "createdAt", label: "Küldési időpont" },
];

const Notifications = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const limit = 50;

  const fetchData = (currentPage, query) => {
    setLoading(true);
    axiosInstance
      .get(
        `/api-admin/notifications?page=${currentPage}&limit=${limit}&search=${query}`
      )
      .then((response) => {
        setData(response.data.result);
        setTotalPages(response.data.totalPages);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData(page, searchQuery);
  }, [page, searchQuery]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reseteljük az oldalszámot új keresésnél
  };

  return (
    <div>
      {/* Keresőmező */}
      {/* <input
        type="text"
        placeholder="Cég keresése..."
        value={searchQuery}
        onChange={handleSearchChange}
        className="search-input"
      /> */}

      <DataTable
        dataList={data}
        createButtonLink={"/new-notification"}
        createButtonText={"Új értesítés létrehozása"}
        editable={true}
        title={"Értesítés lista"}
        columns={columns}
        operationLink={"edit-notification"}
        loading={loading}
      />

      {!loading && (
        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination">
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setPage(page - 1)}>
                  Előző
                </button>
              </li>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      page === pageNumber ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setPage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                )
              )}

              <li
                className={`page-item ${page === totalPages ? "disabled" : ""}`}
              >
                <button className="page-link" onClick={() => setPage(page + 1)}>
                  Következő
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
};

export default Notifications;
